import React from 'react';

import type { ChatType } from '@modules/types/graphql';

type ChatsManagerFilters = {
    type?: ChatType;
    entityId?: string;
    ownerId?: string;
};

export type ChatsManagerContextValue = {
    filters: ChatsManagerFilters | null;
    onSetFilters: (payload: ChatsManagerFilters) => void;
    onResetFilters: () => void;
};

// @ts-ignore
const ChatsManagerContext = React.createContext<ChatsManagerContextValue>({});

type ChatsManagerProviderProps = {
    children: React.ReactNode;
};

const ChatsManagerProvider = (props: ChatsManagerProviderProps) => {
    const { children } = props;

    const [filters, setFilters] = React.useState<ChatsManagerFilters | null>(null);

    const handleSetFilters = React.useCallback(
        (payload: ChatsManagerFilters) => setFilters(payload),
        [],
    );

    const handleResetFilters = React.useCallback(() => setFilters(null), []);

    const ctx = React.useMemo(
        () => ({
            filters,
            onSetFilters: handleSetFilters,
            onResetFilters: handleResetFilters,
        }),
        [filters, handleSetFilters, handleResetFilters],
    );

    return <ChatsManagerContext.Provider value={ctx}>{children}</ChatsManagerContext.Provider>;
};

const useChatsManager = () => React.useContext(ChatsManagerContext);

export { ChatsManagerProvider, useChatsManager };
